export const generateServiceQuoteTemplate = ({
  clientName,
  clientEmail,
  phone,
  selectedService,
  message,
}) => {
  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h2 style="color: #333; border-bottom: 2px solid #eee; padding-bottom: 10px;">New Service Quote Request</h2>
      
      <div style="background: #f9f9f9; padding: 20px; border-radius: 5px; margin: 20px 0;">
        <h3 style="color: #444; margin-top: 0;">Service Details</h3>
        <p style="margin: 5px 0;"><strong>Requested Service:</strong> ${selectedService}</p>
      </div>

      <div style="background: #f9f9f9; padding: 20px; border-radius: 5px; margin: 20px 0;">
        <h3 style="color: #444; margin-top: 0;">Contact Information</h3>
        <p style="margin: 5px 0;"><strong>Name:</strong> ${clientName}</p>
        <p style="margin: 5px 0;"><strong>Email:</strong> ${clientEmail}</p>
        <p style="margin: 5px 0;"><strong>Phone:</strong> ${phone}</p>
      </div>

      <div style="background: #f9f9f9; padding: 20px; border-radius: 5px; margin: 20px 0;">
        <h3 style="color: #444; margin-top: 0;">Message</h3>
        <p style="margin: 5px 0; white-space: pre-line;">${message}</p>
      </div>
    </div>
  `;

  return {
    subject: `New Service Quote Request - ${selectedService} - ${clientName}`,
    html,
  };
};
